// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'v726demo1',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: false,
  apiUrl: 'https://your-domain.com/api',
  baseURL: 'http://uat.speed2u.com.my/tender2u/api',
  mainURL: 'http://uat.speed2u.com.my/tender2u'

  // baseURL: 'https://www.tender2u.com/tender2u/api',
  // mainURL: 'https://www.tender2u.com/tender2u'

  // baseURL: 'http://127.0.0.1:8082/api',
  // mainURL: 'http://127.0.0.1:8082'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
